module.exports = __webpack_public_path__ + "static/10-9a81a5ce49464c104ed6b66a4dd9410a.jpg";